module.exports = __webpack_public_path__ + "img/copy.c45f90e0.svg";